import { isValidEmail } from "./isValidEmail"

export const doesEmailContain = (text: string) => 
    (email: string): boolean =>
        isValidEmail(email) && !!email.match(text)